import { config } from '@/src/lib/config/api-config'

class AquisgranaClient {
  private get baseUrl() {
    return config.baseUrl
  }

  /** GET request — used for /codes/* endpoints */
  async get<T>(path: string, params?: Record<string, string>): Promise<T> {
    const url = new URL(`${this.baseUrl}${path}`, window.location.origin)
    if (params) {
      Object.entries(params).forEach(([k, v]) => url.searchParams.set(k, v))
    }

    const res = await fetch(url.toString(), {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    })

    if (!res.ok) {
      throw new Error(`API GET ${path} failed with status ${res.status}`)
    }

    return res.json() as Promise<T>
  }

  /** POST request — used for /admissions/* endpoints */
  async post<T>(path: string, body: unknown, params?: Record<string, string>): Promise<T> {
    const url = new URL(`${this.baseUrl}${path}`, window.location.origin)
    if (params) {
      Object.entries(params).forEach(([k, v]) => url.searchParams.set(k, v))
    }

    const res = await fetch(url.toString(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })

    if (!res.ok) {
      throw new Error(`API POST ${path} failed with status ${res.status}`)
    }

    return res.json() as Promise<T>
  }
}

export const apiClient = new AquisgranaClient()
